import {
  AlignmentType,
  Footer,
  Header,
  ImageRun,
  Paragraph,
  TextRun,
} from "docx";
import { zipcode_header } from "../docImages/zipcode";

export const styles_zipcode = {
  companyId: ["12430"],
  companyName: "Zipcode",
  font: "Poppins",
  titleSize: 18,
  textSize: 18,
  lineSpacing: 300,
  marginRight: 750,
  marginLeft: 750,
  beforeParagraph: 100,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 0,
          after: 550,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new ImageRun({
            data: zipcode_header,
            transformation: {
              width: 680,
              height: 80,
            },
          }),
        ],
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        spacing: {
          before: 300,
          after: 0,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "WWW.ZIPCODE.COM.AR – SOPORTE@ZIPCODE.COM.AR – TEL +54911 3333 1995 @ZIPCODE.AR",
            size: 15,
            font: "Helvetica Neue",
          }),
        ],
      }),
      new Paragraph({
        spacing: {
          before: 60,
          after: 60,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "DIRECCION CABA: Libertador 6350, Belgrano, CABA. Piso 4. Oficina B      PCIA DE BS AS: Uruguay 6991, San Fernando. Edificio Park 10. Oficina 503",
            size: 15,
            font: "Helvetica Neue",
          }),
        ],
      }),
      new Paragraph({
        spacing: {
          before: 60,
          after: 60,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "Z",
            size: 15,
            font: "Helvetica Neue",
          }),
        ],
      }),
    ],
  }),
};
